const translations = {
    'production.burner': 'Burner %d',
    'production.blacksmithTargetTools': 'Blacksmith tool target: %d',
    'production.blacksmithTargetWeapons': 'Blacksmith weapon target: %d',
    'production.blacksmithInputWood': 'Blacksmith wood input',
    'production.blacksmithInputIngots': 'Blacksmith ingots input',
    'production.blacksmithInputLeather': 'Blacksmith leather input',
    'production.blacksmithOutputTools': 'Blacksmith tools queued',
    'production.blacksmithOutputWeapons': 'Blacksmith weapons queued',
    'production.campWaiting': 'Camp wood waiting: %d',
    'production.charcoalInput': 'Charcoal input: %d %s',
    'production.charcoalOutput': 'Charcoal output: %d',
    'production.coldDebt': 'Cold debt: %s',
    'production.farmer': 'Farmer %d',
    'production.fishStock': 'Fish stock: %d/%d',
    'production.fisher': 'Fisher %d',
    'production.foodHours': 'Food supply: %s h (need %s h)',
    'production.forestStock': 'Forest stock: %d',
    'production.goldMiner': 'Gold miner %d',
    'production.hunter': 'Hunter %d',
    'production.lumberIdle': 'Lumber camp idle (no trees).',
    'production.lumberWork': 'Lumber camp work (tree age %d)',
    'production.mason': 'Mason %d',
    'production.miner': 'Miner %d',
    'production.minter': 'Minter %d',
    'production.noBurners': 'No burners assigned.',
    'production.noFarmers': 'No farmers working.',
    'production.noFishers': 'No fishers assigned.',
    'production.noGoldMiners': 'No gold miners assigned.',
    'production.noHunters': 'No hunters working.',
    'production.noMasons': 'No masons assigned.',
    'production.noMiners': 'No miners assigned.',
    'production.noMinters': 'No minters assigned.',
    'production.noQuarrymen': 'No quarrymen assigned.',
    'production.noSmelters': 'No smelters assigned.',
    'production.noSmiths': 'No smiths assigned.',
    'production.noSmokers': 'No smokers assigned.',
    'production.noWeavers': 'No weavers assigned.',
    'production.populationGrowth': 'Population growth',
    'production.modal.title': '%s / %s',
    'production.modal.progress': 'Progress',
    'production.modal.storage': 'Input/output storage',
    'production.modal.workers': 'Workers',
    'production.modal.inputLine': 'Input %s: %s (cap %s)',
    'production.modal.outputLine': 'Output %s: %s (cap %s)',
    'production.modal.setInputCap': 'Set input cap (%s)',
    'production.modal.setOutputCap': 'Set output cap (%s)',
    'production.modal.noCap': 'no cap',
    'production.modal.noProgress': 'No active workers.',
    'production.modal.noStorage': 'No storage for this building.',
    'production.quarryman': 'Quarryman %d',
    'production.sawmillInput': 'Sawmill input: %d %s',
    'production.sawmillOutput': 'Sawmill output: %d %s',
    'production.sawmillWork': 'Sawmill work (1 %s -> %d %s)',
    'production.storage.title': 'Input / output storage',
    'production.tile.sawmill': 'Sawmill',
    'production.tile.charcoal': 'Charcoal pit',
    'production.tile.blacksmithTools': 'Blacksmith (tools)',
    'production.tile.blacksmithWeapons': 'Blacksmith (weapons)',
    'production.tile.inputNone': 'Input: -',
    'production.progress': 'Progress: %d/%d',
    'production.section': 'Production',
    'production.setBlacksmithToolsTarget': 'Set tool target',
    'production.setBlacksmithWeaponsTarget': 'Set weapon target',
    'production.smelter': 'Smelter %d',
    'production.smithTool': 'Smith %d (tools)',
    'production.smithWeapon': 'Smith %d (weapons)',
    'production.smoker': 'Smoker %d',
    'production.weaver': 'Weaver %d',
    'production.wildlife': 'Wildlife: %d',
};

export default translations;
